export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-6.5f778762.png";